import React, { useContext } from "react";

import AllCash from "../context/AllCash"

const useAllCash = () => {
    const doc = useContext(AllCash);
  return doc;
}

export default useAllCash